import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Menu, Container, Divider, Header, Card, Label, Modal, Dropdown, Button, Icon, List } from 'semantic-ui-react';
import { useInstruments } from '../../hooks/useInstruments';
import { useVoiceTypes } from '../../hooks/useVoiceTypes';
import { parseInstString } from '../../util/InstStrings';
import { EditSongVersion } from './EditSongVersion';
import { CardComposer } from '../cards/CardComposer';
import { CardTextAuthor } from '../cards/CardTextAuthor';
import { CardSongCycle } from '../cards/CardSongCycle';
import { CardProfile } from '../cards/CardProfile';
import { CardSongVersion } from '../cards/CardSongVersion';
import { InstrumentationCard } from '../cards/InstrumentationCard';
import { RangeDisplay } from './RangeDisplay';
import { RuleEntry } from '../common/RuleEntry';
import { Elastic } from '../common/Elastic';
import { useAuth0 } from '@auth0/auth0-react';
import RoleWrapper from "../common/RoleWrapper";
import { DeleteSongVersion } from './deletes/DeleteSongVersion';



export const ViewSong = () => {
  const instrumentMap = useInstruments();
  const voiceTypeMap = useVoiceTypes();
  const [ data, setData ] = useState();
  const [ title, setTitle ] = useState('');
  const [ composer, setComposer ] = useState();
  const [ arranger, setArranger ] = useState(<></>);
  const [ textAuthors, setTextAuthors ] = useState(<></>);
  const [ translators, setTranslators ] = useState(<></>);
  const [ info, setInfo ] = useState();
  const [ displayVersion, setDisplayVersion ] = useState({});
  const [ versionBar, setVersionBar ] = useState();
  const [ instrumentation, setInstrumentation ] = useState();
  const [ voiceTypes, setVoiceTypes ] = useState();
  const [ rangeDisplay, setRangeDisplay ] = useState();
  const { id } = useParams();
  const { isAuthenticated, isLoading, getIdTokenClaims} = useAuth0();
  const [roles, setRoles] = useState([]); // for role identification
  const namespace = "http://myapp.com"; // for the role selection
  const props = [
    'alternate_title',
    'arranger_id',
    'audio_urls',
    'commission',
    'composition_end_date',
    'composition_start_date',
    'created_at',
    'dedication',
    'discography_label',
    'publisher',
    'duration',
    'id',
    'languages',
    'notes',
    'pdf_urls',
    'premiere_date',
    'public_domain_text',
    'purchase_urls',
    'range_high_id',
    'range_low_id',
    'score_image_urls',
    'sequence',
    'song_cycle_version_id',
    'song_id',
    'text',
    'text_publication_date',
    'text_source_notes',
    'title',
    'updated_at',
    'version_name'
  ];
  const preformatted = [
    'commission', 'dedication', 'text'
  ];

  const editButton = (
    <Button basic icon labelPosition="left">
      <Icon name="edit"/>
      Edit
    </Button>
  );

  const cloneButton = (
    <Button basic icon labelPosition="left">
      <Icon name="copy"/>
      New from current
    </Button>
  )

  const newButton = (
    <Button basic icon labelPosition="left">
      <Icon name="add"/>
      New
    </Button>
  )

  const deleteButton = (
    <Button basic icon labelPosition="left">
      <Icon name="trash alternate"/>
      Delete
    </Button>
  )

  function onVersionEdit(version) {
    console.log("on version edit", version);
  }

  function timeconvert(seconds){
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);
    let secs = seconds % 60;

    let hh = String(hours).padStart(2, "0");
    let mm = String(minutes).padStart(2, "0");
    let ss = String(secs).padStart(2, "0");

    return `${hh}:${mm}:${ss}`;

  }

  useEffect(() => {
    const fetchRoles = async () => {
      if (isAuthenticated) {
        const claims = await getIdTokenClaims();
        setRoles(claims[namespace + "//roles"] || []);
      }
    };
    fetchRoles();
  }, [isAuthenticated, getIdTokenClaims]);

  useEffect(() => { 
    if (!data) return;
    console.log("display version", displayVersion);


    // build rows
    const hiddenProps = [
      "song_id",
      "id",
      "commission",
      "title",
      "public_domain_text",
      "updated_at",
      "created_at",
      "version_name",
      "dedication",
      "audio_urls",
      "pdf_urls",
      "purchase_urls",
      "score_image_urls",
      "text_publication_date",
      "premiere_date",
      "composition_end_date",
      "arranger_id",
      "range_high_id",
      "range_low_id",
      "song_cycle_version_id",
      "text"
    ];

    // Only expose text when explicitly marked public domain
    if (displayVersion.version_info.public_domain_text === true) {
      hiddenProps.splice(hiddenProps.indexOf("text"), 1);
    }




    let rows = props.filter(p => !hiddenProps.includes(p)).map((p, i) => {
      // trying to convert duration
      let value;

      if( p == "duration"){
        value = timeconvert(displayVersion.version_info[p])
      } else{
        value = displayVersion.version_info[p];
      }

      
      if (value !== null && value !== undefined && value !== "" && p !== "arranger_id" && p !== "id" && value !== false) {
        let classes = [];
        if (preformatted.indexOf(p) != -1) {
          classes.push('as-is');
        }
        const k = p.replace(/(\W|_)+/g, ' ');
        return (
          <Grid.Row key={i}>
            <Grid.Column width={3} className='text-align-right'><strong className='text-capitalize'>{k}</strong></Grid.Column>
            <Grid.Column width={10} className={classes.join(' ')}>{value}</Grid.Column>
          </Grid.Row>
        );
      } else {
        return;
      }
    });
    setInfo(
      <div>
        <Header as='h3' color='green' className='subtitle'>Song Data</Header>
        <Grid>
          {rows}
        </Grid>
      </div>
    );

    const ddOptions = data.versions.map((v, i) => {
      return {
        text: v.version_info.version_name,
        value: i
      };
    });
  
    const dropdown = (
      <Dropdown selection
        options={ddOptions}
        defaultValue={0}
        onChange={(e, val) => {
          e.preventDefault();
          console.log("changing version to", val.value);
          setDisplayVersion(data.versions[val.value]);
          setTitle(data.versions[val.value].version_info.title);
        }}
      />
    );

    const editModal = (
      <EditSongVersion openButton={editButton} onSuccess={onVersionEdit} version={displayVersion} instrumentMap={instrumentMap} vtMap={voiceTypeMap} songId={displayVersion.songId} />
    )
  
    const cloneModal = (
      <EditSongVersion openButton={cloneButton} onSuccess={onVersionEdit} version={displayVersion} cloning={true} instrumentMap={instrumentMap} vtMap={voiceTypeMap} songId={displayVersion.songId}/>
    )
  
    const newModal = (
      <EditSongVersion openButton={newButton} onSuccess={onVersionEdit} instrumentMap={instrumentMap} vtMap={voiceTypeMap}/>
    )

    const deleteModal = (
      <DeleteSongVersion openButton={deleteButton} onSuccess={onVersionEdit} version={displayVersion} instrumentMap={instrumentMap} vtMap={voiceTypeMap} songId={displayVersion.songId} />
    )

    const modalButtons = (
      <RoleWrapper roles={roles} requiredRole="Editor">
        <Dropdown
          text="Edit Actions"
          icon="dropdown"
          button
          className="primary"
        >
          <Dropdown.Menu>
            <Dropdown.Item>
              {editModal}
            </Dropdown.Item>

            <Dropdown.Item>
              {cloneModal}
            </Dropdown.Item>

            <Dropdown.Item>
              {newModal}
            </Dropdown.Item>

            <Dropdown.Item>
              {deleteModal}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </RoleWrapper>
    );
      
    //const modalButtons = isAuthenticated ? (
      //<span>
       // {editModal} {cloneModal} {newModal}
      //</span>
    //) : null;

    setVersionBar(
      <div className='song-version-bar'>
        <span>Version: {dropdown}</span> 
        <span>{modalButtons}</span>
      </div>
    );
  }, [displayVersion, instrumentMap]);

  useEffect(() => {
    if (!data) return;
    if (Object.keys(instrumentMap).length > 0 && Object.keys(displayVersion).length > 0) {
      const insts = parseInstString(displayVersion.version_info.instrumentation_string);
      if (insts.type) {
        const instList = InstrumentationCard(insts, instrumentMap);

        setInstrumentation(
          <div>
            <Header as='h3' color='green' className='subtitle'>Instrumentation</Header>
            <List size='big'>
              {instList}
            </List>
          </div>
        );
      }
    }
  }, [displayVersion, instrumentMap]);

  useEffect(() => {
    if (!data) return;
    if (Object.keys(voiceTypeMap).length > 0 && Object.keys(displayVersion).length > 0) {
      const vts = parseInstString(displayVersion.version_info.voice_type_string);
      if (vts.type) {
        const vtList = InstrumentationCard(vts, voiceTypeMap);
        setVoiceTypes(
          <div>
            <Header as='h3' color='green' className='subtitle'>Voice Types</Header>
            <List size='big'>
              {vtList}
            </List>
          </div>
        );
      }

      if (!displayVersion.ranges) {
        setRangeDisplay(<></>);
      } else {
        setRangeDisplay(
          <div>
            <Header as='h3' color='green' className='subtitle'>Ranges</Header>
            <RangeDisplay ranges={displayVersion.ranges} vtMap={voiceTypeMap}/>
          </div>);
      }
    }
  }, [displayVersion, voiceTypeMap]);

  useEffect(() => {
    if (!data) return;
    const versions = data.versions;
    
    const composerData = { profile: data.composer };
    const composerCard = (<div>
        <Header as='h3' color='blue' className='subtitle'>Composer</Header>
        <CardComposer data={composerData} id={data.composer_id} />
      </div>);
    setComposer(composerCard);

    if (!!versions.length) {


      setDisplayVersion(versions[0]);
      console.log(versions[0]);
      setTitle(versions[0].version_info.title);
    }
  }, [data]);

  useEffect(() => {

    if (!displayVersion.arranger || displayVersion.arranger.id === 0) {
      setArranger(<></>);
    } else {
      const arrData = { profile: displayVersion.arranger };
      setArranger(<div>
        <Header as='h3' color='blue' className='subtitle'>Arranger</Header>
        <CardComposer data={arrData} id={arrData.id} />
      </div>);
    }

    if (!displayVersion.text_authors) {
      setTextAuthors(<></>);
    } else {
      const cards = displayVersion.text_authors.map((author) => {
        const authorData = { profile: author };
        return (<CardTextAuthor data={authorData} id={author.id} />); // Custom card for redirecting
      });
      setTextAuthors(<div>
        <Header as='h3' color='blue' className='subtitle'>Text Authors</Header>
        {cards}
      </div>);
    }

    if (!displayVersion.translators) {
      setTranslators(<></>);
    } else {
      const cards = displayVersion.translators.map((xlator) => {
        const xlatorData = { profile: xlator };
        return (<CardComposer data={xlatorData} id={xlator.id} key={xlator.id}/>);
      });
      setTranslators(<div>
        <Header as='h3' color='blue' className='subtitle'>Translators</Header>
        {cards}
      </div>);
    }

  }, [displayVersion]);

  
  useEffect(()=> {
    async function getData() {
      const result = await fetch(`/go/api/v1/songs/search/${id}`);
      const json = await result.json();
      if (!json.hits || !json.hits.hits.length) {
        return;
      }
      const src = json.hits.hits[0]._source;
      src.versions = src.versions.map(v => {
        const result = {...v};
        if (result.arranger === null) {
          result.arranger = {};
        }
        if (result.ranges === null) {
          result.ranges = [];
        }
        if (result.text_author_ids === null) {
          result.text_author_ids = [];
        }
        if (result.text_authors === null) {
          result.text_authors = [];
        }
        if (result.translators === null) {
          result.translators = [];
        }
        if (result.translator_ids === null) {
          result.translator_ids = [];
        }
        return result;
      });
      setData(src);
      console.log("src", src);
    }

    // dev left off switching display versions error
  
    getData();
  },[]);

  const debugButtonCallback = () => {
    console.log("insts", Object.keys(instrumentMap).length, instrumentMap);
    console.log("displayver", displayVersion);
    console.log("vts", voiceTypeMap);
  };
  
  return (
    <Container className='view-container'>
      <Grid>
        <Grid.Column width={3}>
          {composer}
          <Divider hidden />
          {arranger}
          <Divider hidden />
          {textAuthors}
          <Divider hidden />
          {translators}
        </Grid.Column>
        <Grid.Column width={13}>
          {/* <Button onClick={debugButtonCallback}>Debug</Button> */}
          <Header as='h3' color='green' className='subtitle'>Song </Header>
          <Header as='h1' className='title' size='huge'>{title}</Header>
          {versionBar}
          <Divider hidden />
          {voiceTypes}
          <Divider hidden />
          {rangeDisplay}
          <Divider hidden />
          {instrumentation}
          <Divider hidden />
          {info}
        </Grid.Column>
      </Grid>
    </Container>
  );
};
